import { useEffect, useMemo, useRef, useState } from "react";
import { shareReplay, type Observable, type Subscription } from "rxjs";

export function useObservable<T>(observable$: Observable<T>, init: T): T {
  const myObservable$ = useMemo(
    () => observable$.pipe(shareReplay({ bufferSize: 1, refCount: true })),
    [observable$],
  );

  const subscription = useRef<Subscription | undefined>(undefined);
  const [value, setValue] = useState(() => {
    let lastValue = init;

    subscription.current = myObservable$.subscribe((value) => {
      lastValue = value;
    });

    return lastValue;
  });

  useEffect(() => {
    return () => {
      subscription.current?.unsubscribe();
      subscription.current = undefined;
    };
  }, [myObservable$]);

  useEffect(() => {
    const sub = myObservable$.subscribe((value) => {
      setValue(() => value);
    });

    return () => {
      sub.unsubscribe();
    };
  }, [myObservable$]);

  return value;
}
